import makeStyles from '@mui/styles/makeStyles'
import { paidConsumerDesktopNavHeight, paidConsumerMobileNavHeight } from '../../../../components/app-toolbar-paid-consumer/style'

export const useStyles = makeStyles(({ breakpoints }) => ({
  appBarContainer: {
    position: 'fixed',
    zIndex: 1200,
    background: '#FFF',
    top: 0,
    left: 0,
    width: '100%',
    padding: 0
  },
  container: {
    minHeight: `calc(100vh - ${paidConsumerMobileNavHeight}px)`,
    marginTop: paidConsumerMobileNavHeight,
    [breakpoints.up('lg')]: {
      minHeight: paidConsumerDesktopNavHeight,
      marginTop: paidConsumerDesktopNavHeight
    }
  },
  mainContainer: {
    flex: 1
  }
}))
